import React, { useEffect, useRef, useState } from 'react';
import {
    ContainerFoodChild, 
    ContainerFoodImage,
    FoodPerimeterImage,
    FoodImage, 
    ContainerFoodText, 
    FoodTitle, 
    FoodPrice, 
    FoodDescription,
    
    ContainerWineChild,
    ContainerWineImage,
    WineImage,
    ContainerWineText,
    ContainerWineTextChildForNameAndFlag,
    ContainerWineTextChild,
    ContainerButtomForViewMoreAndLess,
    ContainerFormObjectChildButton,
    ContainerCircleForElementTheWine,
    CircleForElementTheWine,
    ContainerWineChildTextTheWineAndName,
    ContainerWineChildTextTheWine,
    WineParameterNameBold,
    WineTitle,
    ModalHeader,
    ModalHeaderText,
    ModalContent,
    CloseModalButtom
} from '../../js/Styles'; // Ajusta la ruta según tu estructura

import backgroundFood from '../../../assets/images/backgroundFood.png';

import Modal from 'react-modal'; // Importa react-modal

const customStyles = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
    },
    content: {
        top: '10px',
        left: '10px',
        right: '10px',
        bottom: '10px',
        padding: '0px',
        fontFamily: '"Monserrat", sans-serif',
        overflow: 'none'
    },
};

function Food({food}) {

    const [isModalOpen, setIsModalOpen] = useState(false); // Estado para mostrar/ocultar el modal
    
    // Manejador de eventos cuando se selecciona un vino
    const handleSelectWine = (event) => {
        setIsModalOpen(true);
    };

    // Manejador para cerrar el modal
    const closeModal = () => {
        setIsModalOpen(false);
    };
    
    return (
        <>
            <ContainerFoodChild>
                {
                    food.imagen !== "" ?
                    <ContainerFoodImage>
                        <FoodPerimeterImage src={backgroundFood} onClick={()=> handleSelectWine()}/>
                        <FoodImage src={food.imagen}/>
                    </ContainerFoodImage>
                    : <></>
                }
                <ContainerFoodText>
                    <FoodTitle>{food.nombre}</FoodTitle>
                    <FoodDescription>{food.descripcion}</FoodDescription>
                    <FoodPrice>${food.precio}</FoodPrice>
                    <ContainerButtomForViewMoreAndLess>
                        <ContainerFormObjectChildButton onClick={() => handleSelectWine()}>Ver más</ContainerFormObjectChildButton>
                    </ContainerButtomForViewMoreAndLess>
                </ContainerFoodText>
            </ContainerFoodChild>
            <Modal
                style={customStyles}
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                ariaHideApp={false} 
            >
                {isModalOpen && (
                    <ModalContent>
                        {/* Agrega más detalles del evento aquí */}
                        <ModalHeader style={{justifyContent: "end"}}>
                            <CloseModalButtom onClick={closeModal}>X</CloseModalButtom>
                        </ModalHeader>
                        <ContainerWineChild>
                            <ContainerFoodImage>
                                <FoodImage src={food.imagen} />
                            </ContainerFoodImage>
                            <ContainerWineText>
                                <ContainerWineTextChildForNameAndFlag>
                                    <ContainerWineChildTextTheWineAndName>

                                        <WineParameterNameBold><WineTitle>{food.nombre}</WineTitle></WineParameterNameBold>
                                    </ContainerWineChildTextTheWineAndName>
                                </ContainerWineTextChildForNameAndFlag>
                                <ContainerWineTextChild>

                                    <ContainerWineChildTextTheWine>
                                        <ContainerCircleForElementTheWine>
                                            <CircleForElementTheWine />
                                        </ContainerCircleForElementTheWine>
                                        
                                        <WineParameterNameBold>Descripcion: <WineTitle>{food.descripcion}</WineTitle></WineParameterNameBold>
                                    </ContainerWineChildTextTheWine>
                                    <br/>
                                    <br/>
                                </ContainerWineTextChild>
                            </ContainerWineText>
                        </ContainerWineChild>
                    </ModalContent>
                )}
            </Modal>
        </>
    )
}

export default Food